module.exports = __webpack_public_path__ + "img/UNITY-alt.27a93939.svg";